(function ($, Drupal) {
  'use strict';
  $(document).ready(() => {

    let scrollStartPosition = 0;
    const header = $('header');
    const contentSwitcher = $('#content-switcher');

    let scrollHandler = () => {
      const currentScrollPosition = $(window).scrollTop();
      if (currentScrollPosition === 0) {
        header.removeClass('scrolled');
        header.removeClass('flat');
        contentSwitcher.removeClass('scrolled');
        return null;
      }
      else {
        header.addClass('scrolled');
        contentSwitcher.addClass('scrolled');
      }

      if (scrollStartPosition < currentScrollPosition) {
        header.addClass('flat');
      }
      else {
        header.removeClass('flat');
      }
      scrollStartPosition = currentScrollPosition;
    }

    $(window).scroll(() => scrollHandler());
  })

})(jQuery, Drupal);
